var render = function render(){
  var _vm$content$gre, _vm$content$municipio;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar Lotação ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.local,
      "label": "Local de Lotação",
      "readonly": "",
      "outlined": "",
      "dense": "",
      "hide-details": "true"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', [_vm._v("O local de lotação é uma escola ou creche?")]), _c('v-radio-group', {
    attrs: {
      "hide-details": "",
      "mandatory": "",
      "readonly": "",
      "row": ""
    },
    model: {
      value: _vm.content.ehEscola,
      callback: function ($$v) {
        _vm.$set(_vm.content, "ehEscola", $$v);
      },
      expression: "content.ehEscola"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.content.ehEscola ? _c('v-text-field', {
    attrs: {
      "value": _vm.content.codigo,
      "label": "Código da Escola",
      "readonly": "",
      "outlined": "",
      "dense": "",
      "hide-details": "true"
    }
  }) : _vm._e()], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": (_vm$content$gre = _vm.content.gre) === null || _vm$content$gre === void 0 ? void 0 : _vm$content$gre.nome,
      "label": "GRE",
      "readonly": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": (_vm$content$municipio = _vm.content.municipio) === null || _vm$content$municipio === void 0 ? void 0 : _vm$content$municipio.nome,
      "label": "Município",
      "readonly": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }